import { UserFilter } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum UserFilterActionTypes {
  FetchUserFilters = '[UserFilter] Fetch User Filters',
  FetchUserFiltersSuccess = '[UserFilter] Fetch User Filters Success',
  FetchUserFiltersFail = '[UserFilter] Fetch User Filters Fail',

  SaveUserFilterSuccess = '[UserFilter] Save User Filter Success',
  UpdateUserFilterSuccess = '[UserFilter] Update User Filter Success',
  UpdateUserFilterFail = '[UserFilter] Update User Filter Fail',

  UpdateUserFilters = '[UserFilter] Update User Filters',
  UpdateUserFiltersFail = '[UserFilter] Update User Filters Fail'
}

export class FetchUserFilters implements Action {
  readonly type = UserFilterActionTypes.FetchUserFilters;

  constructor(public payload: boolean = false) {
  }
}

export class FetchUserFiltersSuccess implements Action {
  readonly type = UserFilterActionTypes.FetchUserFiltersSuccess;

  constructor(public payload: UserFilter[]) {
  }
}

export class FetchUserFiltersFail implements Action {
  readonly type = UserFilterActionTypes.FetchUserFiltersFail;

  constructor(public payload: Error) {
  }
}

export class SaveUserFilterSuccess implements Action {
  readonly type = UserFilterActionTypes.SaveUserFilterSuccess;

  constructor(public payload: UserFilter) {
  }
}

export class UpdateUserFilterSuccess implements Action {
  readonly type = UserFilterActionTypes.UpdateUserFilterSuccess;

  constructor(public payload: UserFilter) {
  }
}

export class UpdateUserFilterFail implements Action {
  readonly type = UserFilterActionTypes.UpdateUserFilterFail;

  constructor(public payload: Error) {
  }
}

export class UpdateUserFilters implements Action {
  readonly type = UserFilterActionTypes.UpdateUserFilters;

  constructor(public payload: UserFilter[]) {
  }
}

export class UpdateUserFiltersFail implements Action {
  readonly type = UserFilterActionTypes.UpdateUserFiltersFail;

  constructor(public payload: Error) {
  }
}

export type UserFilterActions =
  | FetchUserFilters
  | FetchUserFiltersSuccess
  | FetchUserFiltersFail
  | SaveUserFilterSuccess
  | UpdateUserFilterSuccess
  | UpdateUserFilterFail
  | UpdateUserFilters
  | UpdateUserFiltersFail;
